<template>
    <div>
        <div class="row no-gutters justify-content-space-evenly align-items-start pt-xl-5">
            <race-card-summary class="mt-4 mt-xl-1" v-for="(race, index) in raceCardSummaries" :key="index"
                               :race="race.raceCardSummary"
                               :raceCardCallback="onRaceCardClicked"
                               :statsCallback="onStatsClicked"
                               :index="index"></race-card-summary>
        </div>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex';

    import RaceCardSummary from '../components/RaceCardSummary';

    import {RaceCardService} from '../services/raceCard.service';

    export default {
        name: 'Home',
        components: {
            RaceCardSummary
        },
        data: function () {
            return {
                raceCardSummaries: {},
                raceStatsUpdate: {
                    promise: undefined,
                    resolve: undefined
                },
                nationalStatsUpdate: {
                    promise: undefined,
                    resolve: undefined
                }
            };
        },
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onRaceCardSummariesResponse(response) {
                // response.sort((a, b) => {
                //    const raceDateA = a.raceDate.substring(a.raceDate.indexOf('-') + 1),
                //          raceDateB = b.raceDate.substring(b.raceDate.indexOf('-') + 1);
                //     return new Date(raceDateB) - new Date(raceDateA);
                // });
                this.raceCardSummaries = response;
                this.setIsLoading(false);
            },
            onStatsClicked(raceCardSummaryIndex) {
                this.setIsLoading(true);
                this.selectedRaceCardSummary = this.raceCardSummaries[raceCardSummaryIndex];
                this.setSelectedRaceCardSummary(this.selectedRaceCardSummary);
                Promise.all([this.raceStatsUpdate.promise, this.nationalStatsUpdate.promise]).then(this.onStatsDataRetrievalComplete.bind(this));
                RaceCardService.getStats(this.raceCardSummaries[raceCardSummaryIndex].id, this.onStatsResponse.bind(this));
                RaceCardService.getNationalStats(this.onNationalStatsResponse.bind(this));
            },
            onStatsResponse(response) {
                const selectedRaceStats = response;
                this.setSelectedRaceStats(selectedRaceStats);
                this.raceStatsUpdate.resolve();
            },
            onNationalStatsResponse(response) {
                const nationalStats = response;
                this.setNationalStatistics(nationalStats);
                this.nationalStatsUpdate.resolve();
            },
            onStatsDataRetrievalComplete() {
                this.setIsLoading(false);
                this.$router.push({path: `/landing/racestatistics`});
            },
            onRaceCardClicked(raceCardSummaryIndex) {
                this.setIsLoading(true);
                this.selectedRaceCardSummary = this.raceCardSummaries[raceCardSummaryIndex];
                RaceCardService.getRace(this.selectedRaceCardSummary.raceInformation[0].id, this.onRaceCardResponse.bind(this));
            },
            onRaceCardResponse(response) {
                const selectedRace = response;
                this.setSelectedRaceCard(this.selectedRaceCardSummary);
                this.setSelectedRace(selectedRace);
                this.setIsLoading(false);
                this.$router.push({path: `/landing/racecard`});
            },
            ...mapMutations(['setSelectedRaceCard', 'setSelectedRace', 'setIsLoading', 'setSelectedRaceStats', 'setSelectedRaceCardSummary', 'setNationalStatistics'])
        },
        created: function () {
            this.raceStatsUpdate.promise = new Promise((resolve => this.raceStatsUpdate.resolve = resolve));
            this.nationalStatsUpdate.promise = new Promise((resolve => this.nationalStatsUpdate.resolve = resolve));
            this.setIsLoading(true);
            RaceCardService.getRaceCardSummaries(this.onRaceCardSummariesResponse.bind(this));
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

